import { EPriceTabView } from "MVVM/@types";
import { colors } from "theme/colors";

export interface ITierPricingData {
  monthly: string;
  monthlyAnnual: string;
  annual: string;
  annualTotal: string;
  discount: string;
}

export const TIER_PRICING: Record<string, ITierPricingData> = {
  ESSENTIALS: {
    monthly: "$0.99",
    monthlyAnnual: "$11.88",
    annual: "$0.89",
    annualTotal: "$10.69",
    discount: "10%",
  },
  PRO: {
    monthly: "$5.99",
    monthlyAnnual: "$71.88",
    annual: "$4.79",
    annualTotal: "$57.48",
    discount: "20%",
  },
  CREATOR_PLAT: {
    monthly: "$14.99",
    monthlyAnnual: "$179.88",
    annual: "$9.74",
    annualTotal: "$116.92",
    discount: "35%",
  },
};

export const TIER_STRIPE_LOOKUP: Record<
  string,
  { [EPriceTabView.Monthly]: string; [EPriceTabView.Annual]: string }
> = {
  ESSENTIALS: {
    [EPriceTabView.Monthly]: "essentials_monthly",
    [EPriceTabView.Annual]: "essentials_yearly",
  },
  PRO: {
    [EPriceTabView.Monthly]: "pro_monthly",
    [EPriceTabView.Annual]: "pro_yearly",
  },
  CREATOR_PLAT: {
    [EPriceTabView.Monthly]: "plat_monthly",
    [EPriceTabView.Annual]: "plat_yearly",
  },
};

export const ANNUAL_STRIPE_LOOKUP: Record<string, string> = {
  ESSENTIALS: "essentials_yearly",
  PRO: "pro_yearly",
  CREATOR_PLAT: "plat_yearly",
};

export const TIER_NAMES: Record<string, string> = {
  FREE: "Free",
  ESSENTIALS: "Basic",
  PRO: "Standard",
  CREATOR_PLAT: "Unlimited",
};

export const getTierAccentColor = (type: string): string => {
  switch (type) {
    case "ESSENTIALS":
      return colors.tierEssentials;
    case "PRO":
      return colors.tierPro;
    case "CREATOR_PLAT":
      return colors.tierPlat;
    default:
      return colors.chalk;
  }
};

export const getTierButtonGradient = (type: string): string => {
  switch (type) {
    case "ESSENTIALS":
      return `linear-gradient(135deg, ${colors.tierEssentials} 0%, ${colors.tierEssentialsDark} 100%)`;
    case "PRO":
      return `linear-gradient(135deg, ${colors.tierPro} 0%, ${colors.tierProDark} 100%)`;
    case "CREATOR_PLAT":
      return `linear-gradient(135deg, ${colors.tierPlat} 0%, ${colors.tierPlatDark} 100%)`;
    default:
      return `linear-gradient(135deg, ${colors.tierEssentials} 0%, ${colors.tierEssentialsDark} 100%)`;
  }
};

export const getTierHeaderGradient = (type: string): string => {
  switch (type) {
    case "ESSENTIALS":
      return `linear-gradient(135deg, ${colors.tierEssentialsAlpha25} 0%, transparent 60%)`;
    case "PRO":
      return `linear-gradient(135deg, ${colors.tierProAlpha25} 0%, transparent 60%)`;
    case "CREATOR_PLAT":
      return `linear-gradient(135deg, ${colors.tierPlatAlpha25} 0%, transparent 60%)`;
    case "FREE":
      return `linear-gradient(135deg, ${colors.chalkAlpha20} 0%, transparent 60%)`;
    default:
      return "transparent";
  }
};

export const getTierBorderColor = (type: string): string => {
  switch (type) {
    case "ESSENTIALS":
      return colors.tierEssentialsAlpha40;
    case "PRO":
      return colors.tierProAlpha40;
    case "CREATOR_PLAT":
      return colors.tierPlatAlpha40;
    default:
      return "rgba(255, 255, 255, 0.06)";
  }
};

export const getTierGlowColor = (type: string): string => {
  switch (type) {
    case "ESSENTIALS":
      return colors.tierEssentialsAlpha20;
    case "PRO":
      return colors.tierProAlpha20;
    case "CREATOR_PLAT":
      return colors.tierPlatAlpha20;
    default:
      return "transparent";
  }
};

export const WINBACK_MONTHLY_COUPON = "WINBACK_MONTHLY_15";

export const WINBACK_ANNUAL_COUPON: Record<string, string> = {
  ESSENTIALS: "WINBACK_ANNUAL_ESSENTIALS_15",
  PRO: "WINBACK_ANNUAL_PRO_25",
  CREATOR_PLAT: "WINBACK_ANNUAL_PLAT_40",
};

export const WINBACK_ANNUAL_DISCOUNT: Record<string, number> = {
  FREE: 0,
  ESSENTIALS: 15,
  PRO: 25,
  CREATOR_PLAT: 40,
};

export const MONTHLY_STRIPE_LOOKUP: Record<string, string> = {
  ESSENTIALS: "essentials_monthly",
  PRO: "pro_monthly",
  CREATOR_PLAT: "plat_monthly",
};

export const getTierBadgeBgColor = (type: string): string => {
  switch (type) {
    case "ESSENTIALS":
      return colors.tierEssentialsAlpha15;
    case "PRO":
      return colors.tierProAlpha15;
    case "CREATOR_PLAT":
      return colors.tierPlatAlpha15;
    default:
      return "transparent";
  }
};
